var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvenSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_3220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 1.5H1.5V22.5H22.5V1.5Z",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6798 9.13965H5.31982V18.6896H18.6798V9.13965Z",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36035 5.32031H10.0904",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.73 5.32031H19.64",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9102 5.32031H15.8202",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0902 12L8.18018 15.82",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8597 12L12.9497 15.82",
    stroke: "#9393B0",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_3220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvenSvgrepocom);
export default __webpack_public_path__ + "static/media/oven_svgrepo.com.0335846442e44ac1d1f9801c825246a7.svg";
export { ForwardRef as ReactComponent };